import React from 'react';
import { Container } from 'react-bootstrap';

export default function Footer() {
    return (
        <footer className="bg-dark text-white text-center py-3 mt-5">
            <Container>
                <p>&copy; 2026 TechHub. Bản quyền thuộc về Nhóm 3 - FER202.</p>
            </Container>
        </footer>
    );
}